module.exports = __webpack_public_path__ + "img/pv_grid_power_off.c589861f.png";